
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_1yrzs_141",
  "trigger": "awsui_trigger_14cnr_1yrzs_175",
  "dropdown": "awsui_dropdown_14cnr_1yrzs_178",
  "nowrap": "awsui_nowrap_14cnr_1yrzs_189",
  "open": "awsui_open_14cnr_1yrzs_192"
};
  